import { render, staticRenderFns } from "./AddPassengerPopup.vue?vue&type=template&id=cd32a580&"
import script from "./AddPassengerPopup.vue?vue&type=script&lang=js&"
export * from "./AddPassengerPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports